import { UseragentDetails } from '@/components/app/types'
import { NextRequest } from 'next/server'
import { parse } from 'express-useragent'

export const parseUserAgent = ua => {
  return parse(ua)
}

export const getUserAgent = (req: NextRequest): UseragentDetails => {
  const useragent = req?.headers['user-agent'] || ''
  return parseUserAgent(useragent)
}

export const getDeviceType = (width: number) => {
  if (width < 768) return { isMobile: true, isTablet: false, isDesktop: false }
  if (width < 1024) return { isMobile: false, isTablet: true, isDesktop: false }
  return { isMobile: false, isTablet: false, isDesktop: true }
}
